import { render, staticRenderFns } from "./UserDetailCompanyCard.vue?vue&type=template&id=f056591c&"
import script from "./UserDetailCompanyCard.vue?vue&type=script&lang=js&"
export * from "./UserDetailCompanyCard.vue?vue&type=script&lang=js&"
import style0 from "./UserDetailCompanyCard.vue?vue&type=style&index=0&id=f056591c&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports